import React from 'react';
import { setLogoutUserController } from 'src/store/actions/controllers.actions';
import { setUserStatus } from '../../../store/actions/user.actions';
import { useAppDispatch } from '../../../hooks/redux-hooks';
import { useEffect } from 'src/utils/useEffect';

const Logout: React.FunctionComponent = () => {

  const dispatch = useAppDispatch();

  const handleLogout = () => {
    dispatch(setLogoutUserController(true));
  };

  useEffect(() => {
    dispatch(setUserStatus("loggingOff"));
    handleLogout();
  }, [handleLogout, dispatch], []);
  
  return null;
}

export default Logout;